import script from "./ViewRef.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewRef.vue?vue&type=script&setup=true&lang=js"

import "./ViewRef.vue?vue&type=style&index=0&id=47029f12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47029f12"]])

export default __exports__